import axios from 'axios';

const checkerAxios = axios.create();

/**
 * 检查静态资源或接口地址是否可访问，默认追加时间戳避免缓存影响。
 * @param {string} url 需要检查的地址。
 * @param {string} [method='get'] 请求方法。
 * @returns {Promise<boolean>} 地址可访问时返回 true，否则返回 false。
 */
export default function checker(url, method = 'get') {
  const separator = url.includes('?') ? '&' : '?';
  const targetUrl = `${url}${separator}datetime=${Date.now()}`;

  return checkerAxios({ url: targetUrl, method })
    .then(() => true)
    .catch(() => false);
}
